import { render, staticRenderFns } from "./Modificar.vue?vue&type=template&id=349b843a"
import script from "./Modificar.vue?vue&type=script&lang=js"
export * from "./Modificar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports